// Email inbox that receives website enquiry form submissions (via FormSubmit, free).
// TODO: replace with Ipsita's real email, then rebuild the static bundle.
// The first submission triggers a one-time activation email from FormSubmit — click it once.
export const FORM_EMAIL = "studio@ipsita.in";
